import useSeo from "@/lib/useSeo";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SuppliesHero from "@/components/supplies/SuppliesHero";
import SuppliesSystemFlow from "@/components/supplies/SuppliesSystemFlow";
import SuppliesList from "@/components/supplies/SuppliesList";
import SuppliesReassurance from "@/components/supplies/SuppliesReassurance";
import SuppliesCTA from "@/components/supplies/SuppliesCTA";

export default function SuppliesPage() {
  useSeo({
    title: "Reorder Supplies — ED Tech Depot | Ink, Paper & Banner Media",
    description:
      "Reorder ink, paper, vinyl, and banner media for your school's wide-format printer. Tell us your printer and we'll match every supply — fast, accurate, and without the guesswork.",
    path: "/supplies",
  });

  return (
    <div data-testid="supplies-page" className="min-h-screen bg-[#F4F6F4]">
      <Header />
      <main>
        <SuppliesHero />
        <SuppliesSystemFlow />
        <SuppliesList />
        <SuppliesReassurance />
        <SuppliesCTA />
      </main>
      <Footer />
    </div>
  );
}
